import { action, makeObservable, observable } from "mobx";
import { FeedbackData, FeedbackSeverity } from "./types";

class FeedbackStore {
  @observable showFeedback = false;
  @observable feedbackData: FeedbackData = {
    message: "",
    severity: FeedbackSeverity.INFO,
    position: "bottom",
    action: null,
  };

  constructor() {
    makeObservable(this);
  }

  @action
  setShowFeedback(showFeedback: boolean, feedbackData?: FeedbackData) {
    this.showFeedback = showFeedback;

    if (feedbackData) {
      this.feedbackData = feedbackData;
    }
  }
}

export default FeedbackStore;
